<template>
  <div>
    <v-card class="mb-12" color="lighten-1">
      <ValidationObserver ref="obs">
        <v-form ref="form" lazy-validation>
          <v-row>
            <v-col>
              <ValidationProvider name="number" rules="required">
                <v-text-field
                  slot-scope="{
                errors,
                valid
              }"
                  :error-messages="errors"
                  :success="valid"
                  v-model="invoice.number"
                  type="number"
                  :label="$t('app.number')"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider name="currency" rules="required">
                <v-select
                  slot-scope="{
                errors,
                valid
              }"
                  :error-messages="errors"
                  :success="valid"
                  v-model="invoice.currency"
                  :items="currencies"
                  :label="$t('app.currency')"
                ></v-select>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider name="type" rules="required">
                <v-select
                  slot-scope="{
                errors,
                valid
              }"
                  :error-messages="errors"
                  :success="valid"
                  v-model="invoice.type"
                  :items="$t('app.invoice_types')"
                  :label="$t('app.type')"
                ></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-file-input
            accept="image/*"
            chips
            show-size
            @change="onFilePicked"
            :label="$t('app.your_logo')"
          ></v-file-input>

          <v-row>
            <v-col>
              <v-menu
                v-model="fromDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :label="$t('app.date')"
                    prepend-icon="mdi-calendar"
                    readonly
                    :value="invoice.date"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  locale="en-in"
                  v-model="invoice.date"
                  no-title
                  @input="fromDateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-row>
                <v-col>
              <v-switch v-model="invoice.have_due_date" :label="$t('app.due_date')"></v-switch>

                </v-col>
                 <v-col    v-if="invoice.have_due_date">
                              <v-menu 
                           
                v-model="invoiceDueDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :label="$t('app.due_date')"
                    prepend-icon="mdi-calendar"
                    readonly
                    :value="invoice.dueDate"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  locale="en-in"
                  v-model="invoice.dueDate"
                  no-title
                  @input="fromDateMenu = false"
                ></v-date-picker>
              </v-menu>
                </v-col>

              </v-row>
  
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-switch v-model="invoice.is_private" :label="$t('app.private')"></v-switch>
            </v-col>
            <v-col>
              <v-text-field v-if="invoice.is_private"  v-model="invoice.password" type="password" :label="$t('app.invoice_password')"></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </ValidationObserver>
    </v-card>
    <v-btn color="primary" :loading="$store.state.fetching" @click="onPreview()">{{$t('app.preview')}}</v-btn>

    <v-btn @click="prevStep" text>{{$t('app.back')}}</v-btn>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { firebase } from "@firebase/app";
import  "@firebase/storage";

import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "StepFive",
  computed: {
    ...mapState(["invoice", "e1"])
  },
  components: { ValidationObserver, ValidationProvider },
  data() {
    return {
      dateDialog: false,
      have_due_date :false,
      invoiceDateMenu: false,
      fromDateMenu :false,
      invoiceDueDateMenu: false,
      fromDateVal: null,
      currencies: ["DZD", "USD", "EUR"]
    };
  },
  methods: {
    ...mapActions(["prevStep","toogleFetching"]),
    onFilePicked(e) {
      if (e.size > 0) {
       
        this.imageName = e.name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(e);
        fr.addEventListener("load", () => {
          // this.imageUrl = fr.result;
           this.toogleFetching()
          this.imageFile = e; // this is an image file that can be sent to server...
          var storageRef = firebase.storage().ref();
          var mountainsRef = storageRef.child(`images/${this.imageName}`);
          mountainsRef.put(this.imageFile).then(snapshot => {
            snapshot.ref.getDownloadURL().then(downloadURL => {
               this.toogleFetching()
              this.invoice.logo = downloadURL;
            });
          });
        });
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    },
    async onPreview() {
      const result = await this.$refs.obs.validate();
      if (result) {
        this.$router.push("preview");
      }
    }
  }
};
</script>

<style scoped>
</style>